import { gql, useMutation } from '@apollo/client'
import { BodyText, Heading, Modal } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'
import { useEffect } from 'react'

import { useValidateOabModalContext } from '../../context'
import { useHandleValidationErrors, useOabTransferringEmailJwt } from '../../hooks'
import validatingSvg from '../../images/oab-verificando.svg'
import styles from '../steps.module.scss'
import {
  TransferOabMutation,
  TransferOabMutationVariables,
} from './__generated__/oab-transferring.graphql'

export const TransferOab = gql`
  mutation TransferOab($input: TransferOabInput!) {
    transferOab(input: $input) {
      profile {
        isOabValid
      }
    }
  }
`

export function OabTransferring() {
  const { resetToInitialStep } = useValidateOabModalContext()
  const { emailJwt } = useOabTransferringEmailJwt()
  const [transferOab, { data, error }] = useMutation<
    TransferOabMutation,
    TransferOabMutationVariables
  >(TransferOab)

  useEffect(() => {
    if (emailJwt) {
      transferOab({
        variables: {
          input: {
            jwt: emailJwt,
          },
        },
        // Catch the error to avoid unhandled promise rejection, error is handled in the useHandleValidationErrors below
      }).catch(() => undefined)
    } else {
      resetToInitialStep()
    }
  }, [emailJwt, resetToInitialStep, transferOab])

  useHandleValidationErrors({ isOabValid: data?.transferOab?.profile?.isOabValid, error })

  return (
    <Modal.Body className={styles.infoModalBody}>
      <Image src={validatingSvg} width={140} height={140} loading="lazy" alt="" />
      <Heading className={styles['infoModalBody-heading']}>Vinculando OAB à conta atual...</Heading>
      <BodyText className={styles['infoModalBody-bodyText']}>
        Aguarde enquanto validamos as informações.
      </BodyText>
    </Modal.Body>
  )
}
